import { getIconCSSForFileProvider } from 'owa-fileprovider-icon';
import { SelectedFilesSource } from '../../types/FilePickerResult';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { FileProviderType } from 'owa-fileprovider-store';

export default function getShareIconForActionPanel(
    filesSource: SelectedFilesSource,
    providerType: FileProviderType,
    isDisabled: boolean
): JSX.Element {
    if (
        filesSource === SelectedFilesSource.LocalComputerFiles ||
        providerType === AttachmentDataProviderType.Mailbox
    ) {
        return getIconCSSForFileProvider(AttachmentDataProviderType.OneDriveConsumer, isDisabled);
    }

    return getIconCSSForFileProvider(providerType, isDisabled);
}
